import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Bookmark = createSvgIcon(
  <path d="m12 16.937 6 3.273V2.25H6v17.96l6-3.273ZM3.75 24V0h16.5v24L12 19.5 3.75 24Z" />,
  'Bookmark'
);

export { Bookmark };
